import { useEffect, useMemo, useState } from 'react';
import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import Fetch from '../../../../core/util/core/Fetch';
import config from '../../../config/config';
import { monitoringCheckCell } from '../../../helpers/monitoringCheckCell';

function Contractualizations({ profileFilter, filterValues, filters }) {
    const [adjustTypes, setAdjustTypes] = useState([]);

    const paths = {
        endpointGetAllAdjustTypes: config.endpoints.backend + 'adjusttypes/getall',
        endpoint: config.endpoints.backend + 'filemonitorings/getContractualizations'
    }

    const entityId = filterValues.pdc_entity_id || profileFilter.pdc_entity_id;

    useEffect(() => {
        const load = async () => {
            const rows = await Fetch.post(paths.endpointGetAllAdjustTypes, { order: [['name', 'ASC']] });
            setAdjustTypes(rows || []);
        }

        load();
    }, []);

    const list = useMemo(() => ({
        labelTitle: 'Contratualização',
        canAdd: false,
        canEdit: false,
        canDelete: false,
        canView: false,
        viewActionColumn: false,
        shouldEmptyList: true,
        formFilters: filters,
        filter: {
            ...profileFilter,
            pdc_entity_id: entityId,
            pdc_project_id: filterValues.pdc_project_id
        },
        columns: [
            {
                name: 'project',
                label: 'Projeto'
            },
            // sem entidade no escopo (perfil por projetos) a coluna identifica de quem e o projeto
            ...(entityId ? [] : [{ name: 'entity', label: 'Entidade' }]),
            ...adjustTypes.map((adjustType) => ({
                name: adjustType.id,
                label: adjustType.name,
                sortable: false,
                cell: (row) => monitoringCheckCell(row[adjustType.id])
            }))
        ],
        ...paths
    }), [adjustTypes, filters, filterValues, entityId]);

    const content = useMemo(() => (
        <CustomList list={list} />
    ), [list]);

    return (
        <CustomListContainer
            labelTitle={list.labelTitle}
            canAdd={false}
            content={content}
        />
    );
}
export default Contractualizations;
